import React, { useState } from "react";
import style from "./DropDown.module.css";
import AssetsPack from "../util/AssetsPack";
import ImageComponent from "./ImageComponent";

interface Card {
  label: string;
  icon?: string;
  isDisable?: boolean;
}

interface DropdownProps {
  label: string;
  options: Card[];
  onSelect: (option: any) => void;
}

const Dropdown: React.FC<DropdownProps> = ({ label, options, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(label);

  const handleSelect = (option: any) => {
    setSelectedOption(option.label);
    setIsOpen(false);
    onSelect(option);
  };

  return (
    <div className={style["dropdown"]}>
      <button
        className={style["dropdown-toggle"]}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedOption}
        <ImageComponent src={AssetsPack.icons.DOWN_ARROW_ICON.default} />
      </button>
      {isOpen && (
        <ul className={style["dropdown-menu"]}>
          {options.map((option, index) => (
            <li key={index} onClick={() => handleSelect(option)}>
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
